import { z } from 'zod';

const DepthModels = z.object({
  orderDisplayedQuantity: z.number(),
  orderEntryDate: z.number(),
  orderPriorityDateTime: z.string(),
  orderSequenceNumber: z.number(),
  uniqId: z.string(),
  uniqueKey: z.string(),
});

const MarketDepthItems = z.object({
  count: z.number(),
  price: z.number(),
  volume: z.number(),
  depthModels: DepthModels.array().nullable(),
});

const MarketDepthsQuery = z.object({
  items: MarketDepthItems.array().nullable(),
  totalCount: z.number(),
});

type MarketDepthsQuery = z.infer<typeof MarketDepthsQuery>;
type MarketDepthItems = z.infer<typeof MarketDepthItems>;

export { MarketDepthsQuery, MarketDepthItems };
